import type * as React from 'react';
import { SeoLinks } from '../../components/SeoLinks';
import { useSelector } from 'react-redux';
import { seoLinksSelector } from '../../selectors/newbuilding';

export const SeoLinksContainer = (): React.JSX.Element => {
  const links = useSelector(seoLinksSelector);

  return <SeoLinks links={links} />;
};
